export default {
  downloadPdf: 150,
};
